import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-list-item-list" }

import Loading from '@lmt-rpb/Loading/Loading.vue';
import type { MergedOfferItemData } from '@interfaces/offer';
import type { OfferListTypoHotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import type { ClientType } from '@/interfaces/common';
import OfferVerified from '@lmt-rpb/OfferVerified/OfferVerified.vue';

interface Props {
	items: MergedOfferItemData[];
	loading?: boolean;
	client?: ClientType;
	hotelData: OfferListTypoHotelData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferListItemList',
  props: {
    items: {},
    loading: { type: Boolean, default: false },
    client: { default: 'at' },
    hotelData: {}
  },
  emits: ['OfferListItem:FetchDetails'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onFetchDetails = (item: MergedOfferItemData, index: number) => {
	if (item.available && !item.availableChecked) {
		item.availableChecked = true;
	}

	emit('OfferListItem:FetchDetails', item, index);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          size: "small",
          class: "offer-list-item-list__loader"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock(OfferVerified, {
            key: `${item.OfferID}${index}`,
            "auto-details": index === 0,
            "offer-data": item,
            "hotel-data": _ctx.hotelData,
            client: _ctx.client,
            "is-verified": !!item.availableChecked,
            class: "offer-list-item-list__item",
            onVerifyOffer: ($event: any) => (onFetchDetails(item, index))
          }, null, 8 /* PROPS */, ["auto-details", "offer-data", "hotel-data", "client", "is-verified", "onVerifyOffer"]))
        }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})